var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    { attrs: { height: 300, preserveAspectRatio: "none" } },
    [
      _c("rect", {
        attrs: { x: "0", y: "40", rx: "4", ry: "4", width: "300", height: "30" }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "0",
          y: "120",
          rx: "4",
          ry: "4",
          width: "400",
          height: "20"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "0",
          y: "170",
          rx: "4",
          ry: "4",
          width: "400",
          height: "20"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "0",
          y: "220",
          rx: "4",
          ry: "4",
          width: "400",
          height: "20"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-908c055e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-908c055e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/GenericLoadingSkeleton.vue
// module id = null
// module chunks = 